import '../styles/main.css';

import App from './pages/app';

async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.bundle.js', {
        scope: '/'
      });
      console.log('ServiceWorker registration successful:', registration);
    } catch (error) {
      console.log('ServiceWorker registration failed:', error);
    }
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  await registerServiceWorker();
  
  window.app = new App();
  
  window.addEventListener('error', (e) => {
    console.error('Global error:', e.error);
    if (window.app && window.app.showToast) {
      window.app.showToast('Terjadi kesalahan sistem', 'error');
    }
  });
  
  window.addEventListener('unhandledrejection', (e) => {
    console.error('Unhandled promise rejection:', e.reason);
    if (window.app && window.app.showToast) {
      window.app.showToast('Terjadi kesalahan jaringan', 'error');
    }
  });
});